import Validation from '@satellite/plugins/Validator.vue';

export default function useValidator() {
  return Validation;
}
